import LoadingCard from "componets/loading-card/loading-card";

export default LoadingCard
